<template>
    <div>
        <div class="hero">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        <span v-if="$route.name === 'images'">
                            Images
                        </span>
                        <span v-if="$route.name === 'image'">
                            <router-link :to="{name: 'images'}">Images</router-link>
                            &rarr;
                            {{ getImage($route.params.id) ? getImage($route.params.id).name : '' }}
                        </span>
                        <span v-if="$route.name === 'image-create'">
                            <router-link :to="{name: 'images'}">Images</router-link>
                            &rarr;
                            New Image
                        </span>
                    </h1>
                </div>
            </div>
        </div>
        <div class="container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {}
        },
        computed: mapGetters(['images']),
        methods: {
            getImage(id) {
                return this.images.find(image => image.id === parseInt(id))
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Images.vue?95a82200